import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import IncomeTypeForm from './IncomeTypeForm';

const IncomeTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const IncomeTypeCreate = (props: any) => {
  return (
    <Create actions={<IncomeTypeActions {...props} />} {...props}>
      <IncomeTypeForm />
    </Create>
  );
};

export default IncomeTypeCreate;
